module.exports = __webpack_public_path__ + "img/BEL.db1e02af.svg";